class AdvertExperienceListController {
  constructor() {
    this.name = 'advertExperienceList';
    this.selected = null;
  }
}

export default AdvertExperienceListController;
